export const wmEN = {
  'skitouring': 'Ski touring',
  'horse': 'On horseback',
  'walking': 'Walking',
  'running': 'Running',
  'cycling': 'Cycling',
  'poi_type': 'Points of Interest',
  'where': 'Places',
  'lang': 'Language',
  'langPlaceholder': 'Select',
  'from': 'Start',
  'to': 'Finish',
  'ascent': 'Slope +',
  'descent': 'Slope -',
  'distance': 'Distance',
  'da te': 'from you',
  'ele_from': 'Starting Elevation',
  'ele_max': 'Max Elevation',
  'ele_min': 'Min Elevation',
  'ele_to': 'Finishing Elevation',
  'difficulty': 'Difficulty',
  'duration_forward': 'Outward Duration',
  'duration_backward': 'Return Duration',
  'Filtri': 'Filters',
  'Cerca': 'Search',
  'tracce': 'Tracks',
  'hiking': 'Hiking',
  'Escursionismo': 'Hiking',
  'escursionismo': 'Hiking',
  'i miei percorsi': 'Draw path',
  'Clicca sulla mappa per avviare la creazione di un percorso':
    'Click on the map to start creating a path',
  'metri': 'Meters',
  'Vedi su OpenStreetMap': 'See on OpenStreetMap',
  'Descrizione Audio': 'Audio Description',
  'il tuo browser non supporta gli elementi audio':
    'Your browser does not support the audio element.',
  'stampa': 'Print',
  'Difficoltà': 'Difficulty',
  'Scala di difficoltà CAI': 'CAI Difficulty Scale',
  'Questo percorso non è accessibile': 'This path is not accessible',
  'Descrizione': 'Description',
  'Punto di partenza': 'Start Point',
  'Punto di arrivo': 'Arrival Point',
  'Dettagli tecnici': 'Technical Details',
  'Attività': 'Activities',
  'Come arrivare': 'How to Get',
  'Bici muscolari': 'Muscle Bikes',
  'Bici elettriche': 'Electric Bikes',
  'Mezzi pubblici': 'Public Transport',
  'Auto Propria': 'Own Car',
  'Punti di interesse': 'POI',
  'Punto di interesse': 'POI',
  'Collegamenti esterni': 'External Links',
  'Downloads': 'Downloads',
  'edit geohub': 'Edit Geohub',
  'NCC': 'NCC',
  'Filtri attivi': 'Active Filters',
  'Reset filtri': 'Reset Filters',
  'Torna alla home': 'Back to Home',
  'Risultati': 'Results',
  'Caricamento in corso.': 'Loading.',
  'Spiacenti non ci sono risultati con questi criteri di ricerca.':
    'Sorry, there are no results with these search criteria',
  'Lista percorsi personali': 'list of paths',
  'nome del percorso': 'name of path',
  'modifica': 'edit',
  'elimina': 'delete',
  'non hai percorsi': 'no paths',
  'al momento non hai nessun percorso salvato.': 'in this moment you dont have any saved paths.',
  'duration': 'Duration',
  'Bentornato!': 'Welcome!',
  'Accedi con le tue credenziali per continuare.': 'Log in with your credentials to continue.',
  'E-mail': 'E-mail',
  "L'e-mail è obbligatoria": 'Email is required',
  "Hai inserito un'e-mail non valida": 'You have entered an invalid email',
  'Password': 'Password',
  'La password è obbligatoria': 'Password is required',
  'Accedi': 'Login',
  'Hai dimenticato la password?': 'Did you forget your password?',
  'Accedi e scarica i tuoi percorsi preferiti': 'Access and download your favorite routes',
  'Puoi anche condividerli con i tuoi compagni di viaggio':
    'You can also share them with your travel companions',
  'Registrati': 'Sign up',
  'Tracce scaricate': 'Downloaded tracks',
  'Utilizzo dati': 'Data usage',
  'Registrazioni': 'Records',
  'Photos': 'Photos',
  'Waypoint': 'Waypoint',
  'Nome': 'Name',
  'inserisci il tuo nome': 'Insert your name',
  "E' necessario inserire un nome": 'A name must be entered',
  'inserisci il tuo cognome': 'Insert your surname',
  "E' necessario inserire un cognome": 'A surname must be entered',
  'Email': 'Email',
  "E' necessario inserire una email": 'It is necessary to insert an email',
  "L'email inserita non è un'email valida": 'The email is invalid',
  'Codice Fiscale': 'Fiscal Code',
  'Perché ti chiediamo il CF?': 'Why do we ask you for the FC??',
  'Il codice fiscale inserito non è valido': 'The fiscal code is not valid',
  'inserisci password': 'enter password',
  "E' necessario inserire la password": 'A password must be entered',
  'Conferma password': 'Confirm password',
  'Ripeti password': 'Repeat the password',
  "E' necessario confermare la password": 'Password confirmation is required',
  'La conferma non corrisponde con la password inserita sopra':
    'The confirmation does not match the password entered above',
  'Cliccando su "Registrati" accetti la nostra': 'By clicking on "Register" you accept our',
  'e i': 'e i',
  'Termini e condizioni': 'Terms and conditions',
  "Errore durante la registrazione dell'utente": 'Error during user registration',
  'Registrazione in corso': 'Registration in progress',
  'Perchè ti chiediamo il Codice Fiscale?': 'Why do we ask you for the Fiscal Code?',
  'Se sei Socia/o CAI inserisci il tuo CF al momento della registrazione. Per te il download delle tappe del Sentiero Italia CAI sarà automaticamente gratuito!':
    'If you are a CAI Member, enter your CF when registering. For you, the download of the stages of the Sentiero Italia CAI will be automatically free!',
  "Origine dell'immagine": 'Source of the image',
  'Annulla': 'Cancel',
  'Dalla libreria': 'From the library',
  'Scatta una foto': 'Take a picture',
  'placeholder': 'Search',
  'Carica File': 'Upload File',
  'Trascina qui il tuo file o clicca per selezionare': 'Drag and drop your file or click to select',
  'Accetta i seguenti formati': 'Accepts the following formats',
  'Tipo di file non supportato': 'File type not supported',
  'Il file non contiene una geometria valida': 'The file does not contain a valid geometry',
  'Errore durante la lettura del file, riprova': 'Error reading file, try again',
  'Si è verificato un errore durante il salvataggio della traccia. Riprova':
    'An error occurred while saving the track. Try again',
  'La traccia è stata salvata correttamente': 'The track has been saved correctly',
  'Scarica il tracciato GPX': 'Download the GPX track',
  'Scarica il tracciato KML': 'Download the KML track',
  'Scarica il tracciato GEOJSON': 'Download the GEOJSON track',
  'Link utili': 'Useful links',
  'apri pdf': 'Open PDF',
  'pendenza': 'Slope',
  'Galleria': 'Gallery',
  'resetta la memoria': 'Reset memory',
  'rimani acceso': 'Stay connected',
  'forza il dispositivo a non spegnersi': 'Force the device to not turn off',
  'PAGINE': 'PAGES',
  'I tuoi dati': 'Your data',
  'pages.profile.projectlink': 'Project',
  'pages.profile.disclaimerlink': 'Disclaimer',
  'pages.profile.creditslink': 'Credits',
  'pages.profile.privacylink': 'Privacy',
  'pages.profile.title': 'Profile',
  'MEMORIA': 'MEMORY',
  'la distanza espressa in metri che indica la cadenza di rilevamento posizione, più il distance filter è minore piu il consumo della batteria sarà maggiore.':
    'The distance expressed in meters indicates the frequency of position detection, the smaller the distance filter, the greater the battery consumption.',
  "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni":
    'To register tracks and then correctly, enable the location permission in the settings.',
  'I miei percorsi': 'My paths',
  'Sentieri': 'Trails',
  'Sentiero': 'Trail',
  'layers': 'Layers',
  '<span class="green">Livello 1: tratti non interessati dall\'alta quota (quota minore di {{orange}} metri)</span>':
    '<span class="green">Level 1: sections not affected by high altitude (altitude less than {{orange}} meters)</span>',
  '<span class="orange">Livello 2: tratti parzialmente in alta quota (quota compresa tra {{orange}} metri e {{red}} metri)</span>':
    '<span class="orange">Level 2: sections partially in high altitude (altitude between {{orange}} meters and {{red}} meters)</span>',
  '<span class="red">Livello 3: in alta quota (quota superiore {{red}} metri)</span>':
    '<span class="red">Level 3: in high altitude (altitude above {{red}} meters)</span>',
  'Un utente è già stato registrato con questa email.':
    'A user has already been registered with this email.',
  "L'email inserita non è corretta. Per favore, riprova.":
    'The email entered is incorrect. Please try again.',
  'La password inserita non è corretta. Per favore, riprova.':
    'The password entered is incorrect. Please try again.',
  'Errore': 'Error',
  'Tempo': 'Time',
  'Velocità media': 'Average speed',
  'Velocità massima': 'Minimum speed',
  'Tipologia di form': 'Form type',
  'Seleziona il tipo di form': 'Select the type of form',
  'File selezionato': 'Selected file',
  'Carica': 'Upload',
  'Aggiornamento effettuato con successo': 'Application updated successfully',
  'Ops!': 'Ops!',
  'Non è stato possibile aggiornare, riprova più tardi':
    'It was not possible to update, try again later',
  'Eliminazione effettuata con successo': 'Deletion successful',
  'Sicuro di voler eliminare questo POI? La rimozione è irreversibile.':
    'Are you sure you want to delete this POI? The removal is irreversible.',
  'Sicuro di voler eliminare questa traccia? La rimozione è irreversibile.':
    'Are you sure you want to delete this track? The removal is irreversible.',
  'Login effettuato con successo': 'Login successful',
  'Logout effettuato con successo': 'Logout successful',
  'Ottieni indicazioni': 'Get indications',
  'Mostra altro': 'Show more',
  'Distanza da te': 'Distance from you',
  'Mostra meno': 'Show less',
  'Mostra tutti': 'Show all',
  'Lunghezza': 'Length',
  'Orario previsto': 'Expected time',
  'Dimensione': 'Size',
  'questo campo è obbligatorio': 'this field is required',
  'Quota': 'Elevation',
  'I miei downloads': 'My downloads',
  'Sei sicuro di voler eliminare la traccia?': 'Are you sure you want to delete the track?',
  'foto dalla galleria': 'photo from the phone gallery',
  'Dimensione massime: 3 photo': 'Maximum 3 photo',
  'Aggiungi': 'Add',
  'Foto': 'Photo',
  '(max 3 photo)': '(max 3 photo)',
  'art-and-culture': 'Art and Culture',
  'tourism': 'Tourism',
  'e-bike': 'E-bike',
  'touring-bike': 'Touring bike',
  'train-trekking': 'Train trekking',
  'road-bike': 'Road bike',
  'ciaspole': 'Snowshoes',
  'adventure': 'Adventure',
  'swimming-snorkeling': 'Swimming and Snorkeling',
  'birdwatching': 'Birdwatching',
  'oeno-gastronomy': 'Oeno-gastronomy',
  'nordic-walking': 'Nordic walking',
  'joelette': 'joelette',
  'mtb': 'MTB',
  'mountain-bike': 'Mountain bike',
  'Ottieni le indicazioni su Google Maps': 'Get directions on Google Maps',
  'Per il punto di partenza': 'For the start point',
  "Per il punto più vicino in linea d'aria": 'For the nearest point in line of sight',
  'Tipo di form': 'Form type',
  'massimo': 'maximum',
  'foto': 'photos',
  'Carica foto dalla libreria': 'Load photos from the library',
  'Luogo': 'Place',
  'Luoghi': 'Places',
  'Percorso': 'Path',
  'Percorsi': 'Paths',
  'salva': 'save',
  'Il salvataggio è stato completato': 'The saving has been completed',
  'Stai modificando le coordinate del POI, vuoi continuare?':
    'You are modifying the coordinates of the POI, do you want to continue?',
  'No': 'No',
  'Sì': 'Yes',
  'Attenzione': 'Attention',
  'Disegna': 'Draw',
  'Esci': 'Exit',
  'Hai salvato correttamente il tuo waypoint. Puoi visualizzarlo accedendo al tuo profilo.':
    'You have saved the waypoint correctly. You can view it by accessing your profile.',
  'Cliccando su "Registrati" accetti la nostra privacy e i termini e condizioni':
    'By clicking on "Register" you accept our privacy and terms and conditions',
  'culture-history': 'Culture and History',
  'environmental-education': 'Environmental Education',
  'eating-sleeping': 'Eating and Sleeping',
  'by-car': 'By Car',
  'Eliminazione': 'Deletion',
  'Elimina': 'Delete',
  'Sei sicuro di voler eliminare questi dati?': 'Are you sure you want to delete this data?',
  'Modifica consenso dati': 'Modify data consent',
  'Dati non sincronizzati': 'Unsynchronized data',
  'Lingua': 'Language',
  'Azione irreversibile': 'Irreversible action',
  'Vuoi veramente eliminare il tuo account? È obbligatorio scrivere "delete account" per procedere.':
    'Do you really want to delete your account? It is necessary to write "delete account" to proceed.',
  'Digita "delete account"': 'Enter "delete account"',
  'Conferma': 'Confirm',
  'La conferma non corrisponde. Digita "delete account" per procedere.':
    'The confirmation does not match. Enter "delete account" to proceed.',
  'Elimina account': 'Delete account',
  'Aggiornamento disponibile': 'Update available',
  "È disponibile una nuova versione dell'app. Aggiorna per ottenere le ultime funzionalità e miglioramenti.":
    'A new version of the app is available. Update now to get the latest features and improvements.',
  'Aggiorna ora': 'Update now',
  'Più tardi': 'Later',
  'Versione disponibile': 'Available version',
  'È stata rilevata una registrazione interrotta. Vuoi riprenderla?':
    'A recording has been interrupted. Do you want to resume it?',
  'Riprendi': 'Resume',
  'Info': 'Info',
  'Chiudi': 'Close',
  'Store non disponibile': 'Store not available',
  "Non è stato possibile aprire direttamente lo store. Prova ad aprire manualmente la pagina dell'app nello store.":
    'It was not possible to open the store directly. Try to manually open the app page in the store.',
  'Aggiornamento obbligatorio': 'Mandatory update',
  "Per continuare a utilizzare l'app è necessario installare l'ultima versione disponibile.":
    'To continue using the app, you must install the latest available version.',
  "È disponibile una nuova versione dell'app.": 'A new version of the app is available.',
  "Dove": "Where",
  "Regione": "Region",
  "Provincia": "Province",
  "Comune": "Municipality",
  'layer': 'Layer',
  'Nessun risultato': 'No results',
  'Condividi': 'Share',
  'Condivisione in corso': 'Sharing in progress',
  'Condivisione non riuscita': 'Sharing failed',
  'Riprova': 'Retry',
  'Aggiungi ai preferiti': 'Add to favorites',
  'Rimuovi dai preferiti': 'Remove from favorites',
  'Preferito': 'Favorite',
  'Non preferito': 'Not favorite',
  'Impossibile aggiornare i preferiti, riprova': 'Could not update favorites, try again',
  'Modifica profilo': 'Edit profile',
  'Cambia foto': 'Change photo',
  'Il nome è obbligatorio': 'Name is required',
  'Il nome non può superare i 255 caratteri': 'Name cannot exceed 255 characters',
  'Cognome': 'Surname',
  'Il cognome non può superare i 255 caratteri': 'Surname cannot exceed 255 characters',
  'Salva': 'Save',
};
